<template>
  <edit-employee-layout :employee-id="empNumber" screen="report-to">
    <div class="orangehrm-horizontal-padding orangehrm-top-padding">
      <oxd-text tag="h6" class="orangehrm-main-title">{{
        $t('pim.report_to')
      }}</oxd-text>
      <oxd-divider />
    </div>
    <employee-supervisors
      :emp-number="empNumber"
      :reporting-methods="reportingMethods"
    ></employee-supervisors>
    <employee-subordinates
      :emp-number="empNumber"
      :reporting-methods="reportingMethods"
    ></employee-subordinates>
    <employee-my-backups v-if="!isEmployee" :emp-number="empNumber">
    </employee-my-backups>
    <employee-backups v-if="!isEmployee" :emp-number="empNumber">
    </employee-backups>
  </edit-employee-layout>
</template>

<script>
import EditEmployeeLayout from '@/orangehrmPimPlugin/components/EditEmployeeLayout';
import EmployeeSupervisors from '@/orangehrmPimPlugin/components/EmployeeSupervisors';
import EmployeeSubordinates from '@/orangehrmPimPlugin/components/EmployeeSubordinates';
import EmployeeBackups from '@/orangehrmPimPlugin/components/backupResponsibilities/EmployeeBackups';
import EmployeeMyBackups from '@/orangehrmPimPlugin/components/myBackup/EmployeeMyBackups';
import UserRoles from '@/orangehrmTrainigPlugin/constants/UserRoles';

const userAuth = window.appGlobal.user;
export default {
  components: {
    'edit-employee-layout': EditEmployeeLayout,
    'employee-supervisors': EmployeeSupervisors,
    'employee-subordinates': EmployeeSubordinates,
    'employee-backups': EmployeeBackups,
    'employee-my-backups': EmployeeMyBackups,
  },
  props: {
    empNumber: {
      type: String,
      required: true,
    },
    reportingMethods: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isViewer() {
      return userAuth.id != parseInt(this.empNumber) &&
        userAuth.roleId != UserRoles.ADMIN.id &&
        !(
          userAuth.subordinates.includes(parseInt(this.empNumber)) &&
          userAuth.roleId == UserRoles.SUPERVISOR.id
        )
        ? true
        : false;
    },
    isEmployee() {
      if (this.isSubordinate) return false;

      return [UserRoles.ESS.id, UserRoles.SUPERVISOR.id].includes(
        userAuth.roleId,
      ) && this.isViewer
        ? true
        : false;
    },
    isSubordinate() {
      if (userAuth.roleId === UserRoles.ADMIN.id) return false;

      return (
        userAuth.subordinates.includes(parseInt(this.empNumber)) &&
        userAuth.roleId == UserRoles.SUPERVISOR.id
      );
    },
    isAuthAdmin() {
      return userAuth.roleId === UserRoles.ADMIN.id;
    },
  },
};
</script>
